<template>
    <div class="position-box" @scroll="listenScroll">
        <div class="scroll-box">
            <div class="kline-head">
                <img class="icon" @click="goBack" src="@/assets/icon_back.png" alt="back">
                <div class="kline-left">
                    <img class="btn-alert" src="@/assets/trend_tabulate.png" alt="" @click="leftShow">
                    <div>{{currency}}/USDC</div>
                </div>
                <div class="kline-right">
                    <img id="fullScreen" class="btn btn-qp" src="@/assets/trend_Full-screen.png" alt="">
                </div>
            </div>
            <div class="info-box">
                <div class="info-head">
                    <ul class="info-left">
                        <li class="price" :class="[ parseFloat(xianjia) < parseFloat(open) ?'red':'']">{{xianjia | toFixed4}}</li>
                        <li class="t1"><span :class="[updown < 0 ?'red':'']"><i v-show="updown > 0">+</i>{{updown}}%</span></li>
                    </ul>
                    <ul class="info-right">
                        <li class="item">
                            <div>{{this.$t("kxt.gao")}}</div>
                            <div class="num">{{maxprice | toFixed4}}</div>
                        </li>
                        <li class="item">
                            <div>{{this.$t("kxt.di")}}</div>
                            <div class="num">{{minprice | toFixed4}}</div>
                        </li>
                        <li class="item">
                            <div>Vol</div>
                            <div class="num">{{volume | toFixed4}}</div>
                        </li>
                    </ul>
                </div>
                <div class="info-foot">
                    <div class="item-box">
                        <div class="item time" :class="{active: tabIdx == 0}" @click="tab(0,2,2,'1min')" data-val="1" data-type="1min" data-chartType="1">1<span>{{this.$t("kxt.fz")}}</span></div>
                        <div class="item time" :class="{active: tabIdx == 1}" @click="tab(1,4,15,'15min')" data-val="15" data-type="15min" data-chartType="1">15<span>{{this.$t("kxt.fz")}}</span></div>
                        <div class="item time" :class="{active: tabIdx == 2}" @click="tab(2,6,60,'60min')" data-val="60" data-type="60min" data-chartType="1">1<span>{{this.$t("kxt.xs")}}</span></div>
                        <div class="item time" :class="{active: tabIdx == 3}" @click="tab(3,7,'1D','1day')" data-val="1D" data-type="1day" data-chartType="1">1<span>{{this.$t("kxt.tian")}}</span></div>
                        <div class="item more" :class="{moreActive: isMore}" @click="moreClick">
                            <div>{{this.$t("kxt.gd")}}</div>
                            <img class="down" src="@/assets/trend_more_gray.png" v-show="!isMore" alt="">
                            <img class="down" src="@/assets/trend_more_light.png" v-show="isMore" alt="">
                        </div>
                        <!-- 更多框 -->
                        <div class="alert-sdt-box" v-show="isMore">
                            <ul class="alert-sdt-ul">
                                <li class="alert-more-list">
                                    <div class="text" :class="{active: timeIdx == 0}" data-val="5" data-type="3min" data-chartType="1" @click="timeClick(0,3,5,'3min')">5<span>{{this.$t("kxt.fz")}}</span></div>
                                    <div class="text" :class="{active: timeIdx == 1}" data-val="30" data-type="30min" data-chartType="1" @click="timeClick(1,5,30,'30min')">30<span>{{this.$t("kxt.fz")}}</span></div>
                                    <div class="text" :class="{active: timeIdx == 2}" data-val="1W" data-type="1week" data-chartType="1" @click="timeClick(2,8,'1W','1week')">1<span>{{this.$t("kxt.zhou")}}</span></div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
             <!-- k线图 -->
            <div id="tv_chart_container" class="kline-box"></div>
            <div class="cont-box">
                <ul class="tab-box">
                    <li class="tab" :class="{active: footIdx == 0}" @click="footTab(0)">{{this.$t("kxt.lswt")}}</li>
                    <li class="tab" :class="{active: footIdx == 1}" @click="footTab(1)">{{this.$t("kxt.cj")}}</li>
                    <li class="tab" :class="{active: footIdx == 2}" @click="footTab(2)">{{this.$t("kxt.jj")}}</li>
                </ul>
                <!-- 历史委托 -->
                <div class="item1-box" v-show="footIdx == 0">
                    <ul class="table-body">
                        <li class="table-tr" v-for="(item,index) in historyDeal" :key="index">
                            <div class="time-box"><span class="type mr" :class="{mc: item.currency_way == 2}">{{item.currency_way | sellType}}</span> <span class="text">{{symbol}}</span><span class="status">{{item.status | statusText}}</span></div>
                            <div class="price-box"><div>{{$t("kxt.jyh")}} {{item.order_sn}}</div></div>
                            <div class="num-box"><div>{{$t("kxt.wtzl")}} {{item.use_num}} {{currency}}</div><div>{{$t("kxt.jye")}} {{(parseFloat(item.use_num)*parseFloat(item.now_price)).toFixed(4)}}</div></div>
                            <div class="price-box"><div>{{$t("kxt.wtjg")}} {{item.now_price}} USDT</div><div>{{$t("kxt.sxf")}} {{(parseFloat(item.use_num)*parseFloat(item.now_price)*(parseFloat(item.rate))/100).toFixed(4)}}</div></div>
                            <div class="price-box date-box" v-if="item.status == 2 && item.true_price > 0"><div>{{$t("kxt.cjjg")}} {{item.true_price}} USDT</div><div>{{item.deal_time | timeTamp}}</div></div>
                            <div class="price-box date-box" v-else><div>{{item.create_time | timeTamp}}</div></div>
                        </li>
                    </ul>
                </div>
                <!-- 成交 -->
                <div class="item1-box" v-show="footIdx == 1">
                    <ul class="table-head">
                        <li class="th">{{this.$t("kxt.sj")}}</li>
                        <li class="th">{{this.$t("kxt.fx")}}</li>
                        <li class="th tc">{{this.$t("kxt.jg")}}</li>
                        <li class="th tc">{{this.$t("kxt.sl")}}</li>
                    </ul>
                    <ul class="table-body">
                        <li class="table-tr trade-box" v-for="(item,index) in klineTrade" :key="index">
                            <div class="td">{{item.ts | timeTamp2}}</div>
                            <div class="td mr" :class="{mc: item.direction == 'sell'}">{{item.direction}}</div>
                            <div class="td tc">{{item.price}}</div>
                            <div class="td tc">{{item.amount | toFixed4}}</div>
                        </li>
                    </ul>
                </div>
                <!-- 简介 -->
                <div class="item2-box" v-show="footIdx == 2">
                    <div class="cont1" v-html="content"></div>
                </div>
                <!-- 暂无数据 -->
                <no-data v-show="isNoData"></no-data>
            </div>
        </div>
        <div class="mask" v-show="isMask" @click="cancle"></div>
        <!-- 左侧弹框  -->
        <div class="alert-bz-wrap" v-show="isLeftShow">
            <ul class="alert-box">
                <li class="alert-li" @click="select('GDCC',1)">
                    <img class="icon" src="@/assets/gdcc.png" alt="">
                    <div class="text">GDCC/USDT</div>
                    <div class="money" :class="[ parseFloat(gdccusdt.close) < parseFloat(gdccusdt.open) ?'red':'']">{{gdccusdt.close | toFixed4}}</div>
                </li>
                <li class="alert-li" @click="select('ETH',3)">
                    <img class="icon" src="@/assets/ETH.png" alt="">
                    <div class="text">ETH/USDT</div>
                    <div class="money" :class="[ parseFloat(ethusdt.close) < parseFloat(ethusdt.open) ?'red':'']">{{ethusdt.close | toFixed4}}</div>
                </li>
                <li class="alert-li" @click="select('BTC',4)">
                    <img class="icon" src="@/assets/BTC.png" alt="">
                    <div class="text">BTC/USDT</div>
                    <div class="money" :class="[ parseFloat(btcusdt.close) < parseFloat(btcusdt.open) ?'red':'']">{{btcusdt.close | toFixed4}}</div>
                </li>
                <li class="alert-li" @click="select('TRX',5)">
                    <img class="icon" src="@/assets/TRX.png" alt="">
                    <div class="text">TRX/USDT</div>
                    <div class="money" :class="[ parseFloat(trxusdt.close) < parseFloat(trxusdt.open) ?'red':'']">{{trxusdt.close | toFixed4}}</div>
                </li>
            </ul>
        </div>
        <div class="btn-box">
            <button class="btn btn-buy" type="button" @click="buy(1)">{{this.$t("kxt.mr")}}</button>
            <button class="btn btn-sell" type="button" @click="buy(2)">{{this.$t("kxt.mc")}}</button>
        </div>
        <!-- 弹窗 -->
        <div class="mask" v-show="isJgShow"></div>
        <!-- 买入 -->
        <div class="alert-buy-box" v-show="isBuy">
            <div class="buy-head">
                <div>{{this.$t("kxt.xj")}} <span class="price" :class="[ parseFloat(xianjia) < parseFloat(open) ?'red':'']">{{xianjia}}</span></div>
                <img class="close" src="@/assets/close.png" @click="close" alt="">
            </div>
            <div class="input-box">
                <input class="input" type="number" min="0" v-model="amount" @keyup="keyAmount()" autocomplete="off" :placeholder="$t('duihuang.qtxje')">
                <div class="text">{{currency}}/USDT</div>
            </div>
            <div class="ky-money" v-show="tradeType == 1">
                <div class="ky-buy">{{this.$t("kxt.ky")}}  <span class="blue">{{usdt_money}} USDT ≈ {{curCurrency}} {{currency}}</span></div>
            </div>
            <div class="ky-money" v-show="tradeType == 2">
                <div>{{this.$t("kxt.ksell")}}  <span class="blue">{{currency_money}} {{currency}} ≈ {{curCurrency}} USDT</span></div>
            </div>
            <div class="rate" v-show="tradeType == 1">{{this.$t("kxt.sxfl")}} {{chainData.buy_rate}}%</div>
            <div class="rate" v-show="tradeType == 2">{{this.$t("kxt.sxfl")}} {{chainData.sell_rate}}%</div>
            <div class="money">{{this.$t("kxt.jye")}} {{totalMoney}} USDT</div>
            <button type="button" class="btn" v-show="tradeType == 1" @click="sureBuy">{{this.$t("kxt.ljmr")}}</button>
            <button type="button" class="btn btn-sell" v-show="tradeType == 2" @click="sureBuy">{{this.$t("kxt.ljmc")}}</button>
        </div>
        <!-- 支付设置 -->
        <div class="alert-pay" v-show="isPayShow">
            <div class="alert-head">
                {{this.$t('tips.zfts')}}
            </div>
            <div class="alert-btn" @click="payJump">{{this.$t('wdkj.sure')}}</div>
        </div>
        <div class="alert-wrap2" v-show="isShow2">
            <div class="alert-head">
                {{this.$t('duihuang.ts')}}
                <img class="icon" src="@/assets/close.png" @click="close" alt="">
            </div>
            <div class="cont">{{btcmTips}}</div>
        </div>
        <div class="mask3" v-show="isShow" @click="close2"></div>
        <div class="pwd-alert-box" v-show="isShow">
            <div class="alert-head">{{$t('usdttb.qsrjymm')}}</div>
            <img class="close" src="@/assets/close.png" @click="close2" alt="">
            <ul class="pwd-box">
                <li class="pwd" v-for="(item,index) in inputList" :key="index"><input class="input pwd-input" v-model="item.val" type="password" maxlength="1" oninput = "value=value.replace(/[^\d]/g,'')" @keyup="nextFocus($event,index)" inputmode="numeric" autocomplete="off"></li>
            </ul>
        </div>
         <img class="go-top" src="@/assets/top.png" alt="" @click="scrollTo" v-show="isTop">
    </div>
</template>
<script>
import noData from '@/components/noData.vue'
import loading from '@/components/loading.vue'
let that;
let vm = null;
export default {
    name: 'kline',
    inject:['reload'],
    data () {
        let data = {
            lang: 'en',
            uid: '',
            token: '',
            widget: null,
            symbolInfo: null,
            tabIdx: 0,
            timeIdx: 5,
            footIdx: 0,
            isMore: false,
            isSdt: false,
            isNoData: false,
            isTop: false,
            message: '',//简介
            leftData: [],
            isMask: false,
            isLeftShow: false,//左侧币种弹窗
            leftIdx: 0,
            tabLeftIdx: 1,
            prevData: [
                {
                    close: 0.1758,
                    high: 0.176,
                    low: 0.1754,
                    open: 0.1758,
                    period: "1min",
                    symbol: "gdcc",
                    time: 1619676240,
                    type: "kline",
                    volume: 91506.79
                }
            ],
            priceScale: 100000,
            PriceScaleMode: 2,
            histime: '',
            open: '',
            newPrice: '0.00',
            updown: '0.000',
            maxprice: '0.00',
            minprice: '0.00',
            volume: '',
            dayvom: '0.00',
            historyList: {},
            historyDeal: [], //成交数据,
            klineTrade: [],//最新成交数据
            jgIdx: 0,
            isShow: false,
            isShow2: false,
            isJgShow: false,
            isBuy: false,
            tradeType: 1,
            timer: null,
            timer2: null,
            timer3: null,
            timerTimes: null,
            symbol:'GDCC/USDT',
            chainData: {},
            content: '',
            amount: '',
            btcm: 1.5,
            usdt: 1,
            btc: '',
            eth: '',
            trx: '',
            xianjia: '0.0000',
            curMoney: '',
            totalMoney: '0.0000',
            btc_money: '0.0000',
            btcm_money: '0.0000',
            usdt_money: '0.0000',
            eth_money: '0.0000',
            trx_money: '0.0000',
            currency: 'GDCC',
            currency_money: 0,
            curCurrency: 0,
            timeType: 2,
            currency_type: 1,
            limit: 100,
            page: 1,
            isPayShow: false,
            btcmTips: '',
            inputList: [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}],
            mr: '',
            mc: '',
            klineData: {},
            websock: null,
            curTimeTap: 0,
            okTimestamp: 0,
            btcusdt: {},
            ethusdt: {},
            gdccusdt: {},
            trxusdt: {},
            timestamp: 0
        };
        return data;
    },
    beforeCreate() {
        that = this;
    },
    created() {
        vm = this;
        let uid = this.uid = localStorage.getItem('uid');
        let token = this.token = localStorage.getItem('token');
        this.lang = localStorage.getItem('user_lang');
        this.currency_type = localStorage.getItem('currency_type') || 1;
        this.symbol = localStorage.getItem('symbol') || 'GDCC/USDT';
        this.timestamp = localStorage.getItem('timestamp') || 0;
        this.mr = this.$t('kxt.mr');
        this.mc = this.$t('kxt.mc');
        var d = Date.now();
        d -= d % (60 * 1000);
        this.curTimeTap = this.prevData[0].time = Number(d/1000);
        this.klineHistoryList();
        this.initWebSocket();
        localStorage.setItem('tim', '2') //默认为1分钟
        localStorage.setItem('type','1min')  //默认为1分钟
        localStorage.setItem('time_type',this.timeType);
    },
    mounted() {
        this.createWidget();
        this.getChainData();
        this.getHistoryDeal();
        this.getMemberInfo();
        this.getNewestcurrency();
        this.check();
        this.getklineTrade();
        this.getKlineTimeAll();
        this.timer = setInterval(()=>{
            this.getNewestcurrency();
        },3000);
        this.timerTimes = setInterval(()=>{
            var okTimestamp = localStorage.getItem('okTimestamp') || 0;
            var curTimestamp = Date.parse(new Date())/1000;
            if((Number(curTimestamp) - Number(okTimestamp)) > 3){
                this.klineHistoryList();
            }
           this.getUpDown();
           this.getklineTrade();
        },2000);
    },
    methods: {
        initWebSocket(){ //初始化weosocket
            const wsuri = this.wsuri();
            this.websock = new WebSocket(wsuri);
            this.websock.onmessage = this.websocketonmessage;
            this.websock.onopen = this.websocketonopen;
            this.websock.onerror = this.websocketonerror;
            this.websock.onclose = this.websocketclose;
        },
        websocketonopen(){ //连接建立之后执行send方法发送数据
            var msg = {'time_type': vm.timeType,'currency_type':vm.currency_type,'uid': vm.uid};
            this.websocketsend(JSON.stringify(msg));
        },
        websocketonerror(){//连接建立失败重连
            this.initWebSocket();
        },
        websocketonmessage(e){ //数据接收
            this.klineData = {};
            var msg = JSON.parse(e.data);
            this.klineData = JSON.parse(e.data);
            vm.xianjia =  msg.close;
            vm.open =  msg.open;
            vm.maxprice = msg.high;
            vm.minprice = msg.low;
            vm.volume = msg.volume;
            this.curTimeTap = this.klineData.time;
            localStorage.setItem('okTimestamp',Date.parse(new Date())/1000);
        },
        websocketsend(Data){//数据发送
            this.websock.send(Data);
        },
        websocketclose(e){  //关闭
            console.log('断开连接',e);
        },
        getChainData(){
            let params = {
                uid: this.uid,
                token: this.token,
                currency_type: this.currency_type
            }
            this.isLoad = true;
            this.$ajax.post('/api/Klineview/getChainData',params).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 200){
                    this.chainData = resData;
                    this.content = this.contHtml(resData.content);
                }else{
                    this.$router.push('/login')
                }
                this.isLoad = false;
            }).catch(function(err){
                console.log(err)
            })
        },
        getUpDown(){
            let params = {
                uid: this.uid,
                token: this.token,
                limit: this.limit,
                page: this.page,
                time_type: 7,
                currency_type: this.currency_type
            }
            this.$ajax.post('/api/Klineview/klineTime',params).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 200){
                    this.klineData = {};
                    var msg = JSON.parse(resData);
                    vm.updown = ((parseFloat(msg.close)/parseFloat(msg.open) - 1)*100).toFixed(3);
                    if(vm.updown != 0){
                        localStorage.setItem('updown',vm.updown)
                    }else{
                        vm.updown = localStorage.getItem('updown')
                    }
                }else{
                    this.$router.push('/login')
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        getKlineTimeAll(){
            let params = {
                uid: this.uid,
                token: this.token
            }
            this.$ajax.post('/api/Klineview/klineTimeAll',params).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 200){
                    this.btcusdt = JSON.parse(resData.btcusdt);
                    this.ethusdt = JSON.parse(resData.ethusdt);
                    this.gdccusdt = JSON.parse(resData.gdccusdt);
                    this.trxusdt = JSON.parse(resData.trxusdt);
                    if(this.symbol == 'GDCC/USDT'){
                        this.xianjia = JSON.parse(resData.gdccusdt).close;
                        this.open = JSON.parse(resData.gdccusdt).open;
                    }else if(this.symbol == 'ETH/USDT'){
                        this.xianjia = JSON.parse(resData.ethusdt).close;
                        this.open = JSON.parse(resData.ethusdt).open;
                    }else if(this.symbol == 'BTC/USDT'){
                        this.xianjia = JSON.parse(resData.btcusdt).close;
                        this.open = JSON.parse(resData.btcusdt).open;
                    }else{
                        this.xianjia = JSON.parse(resData.trxusdt).close;
                        this.open = JSON.parse(resData.trxusdt).open;
                    }
                }else{
                    this.$router.push('/login')
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        klineHistoryList(){//
            let params = {
                uid: this.uid,
                token: this.token,
                limit: this.limit,
                page: this.page,
                time_type: this.timeType,
                currency_type: this.currency_type
            }
            this.$ajax.post('/api/Klineview/klineTime',params).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 200){
                    this.klineData = {};
                    var msg = JSON.parse(resData);
                    this.klineData = JSON.parse(resData);
                    vm.xianjia =  msg.close || '0.0000';
                    vm.open =  msg.open || '0.0000';
                    vm.minprice = msg.low || '0.0000';
                    vm.volume = msg.volume || '0.0000';
                    this.curTimeTap = this.klineData.time;
                }else{
                    this.$router.push('/login')
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        // 历史成交记录
        getHistoryDeal(){//
            let params = {
                uid: this.uid,
                token: this.token,
                currency_type: this.currency_type,
                currency_way: 0,
                limit: this.limit,
                page: this.page
            }
            this.$ajax.post('/api/Bail/bailList',params).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 200){
                    if(resData.length > 0){
                        this.isNoData = false
                        this.historyDeal = this.historyDeal.concat(resData);
                        this.curDataLength = resData.length;
                    }else{
                        this.isNoData = this.page > 1 ? false:true;
                        this.curDataLength = resData.length;
                    }
                }else{
                    this.$router.push('/login')
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        getklineTrade(){//最新成交记录
            let params = {
                uid: this.uid,
                token: this.token,
                currency_type: this.currency_type
            }
            this.$ajax.post('/api/Klineview/klineTrade',params).then((res) => {
                let resData = JSON.parse(res.data.data);
                if(res.data.code == 200){
                    this.klineTrade = resData.data;
                }else{
                    this.$router.push('/login')
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        leftShow(){
            this.isLeftShow = true;
            this.isMask = true;
            this.timer3 = setInterval(()=>{
                this.getKlineTimeAll();
            },3000);
        },
        select(bz,type){
            this.websock.close();
            this.initWebSocket();
            clearInterval(this.timer2);
            this.tabIdx = 0;
            this.updown = '0.000';
            this.timer2 = null;
            this.historyDeal = [];
            this.klineTrade = [];
            this.page = 1;
            this.currency = bz;
            this.symbol = bz + '/USDT';
            this.currency_type = type;
            this.isLeftShow = false;
            this.isMask = false;
            localStorage.removeItem('time_type');
            localStorage.setItem('type',type);
            localStorage.setItem('currency_type',type);
            localStorage.setItem('symbol',bz + '/USDT');
            localStorage.setItem('tim', '2') //默认为1分钟
            localStorage.setItem('type','1min')  //默认为1分钟
            this.klineHistoryList();
            this.getCurrency();
            this.getHistoryDeal();
            this.getChainData();
            this.getklineTrade();
        },
        cancle(){
            this.isLeftShow = false;
            this.isBuy = false;
            this.isPayShow = false;
            this.isMask = false;
        },
        toFixed(v) {
            return parseFloat(v).toFixed(4)
        },
        moreClick(){
            this.isMore = !this.isMore;
            this.isSdt = false;
        },
        sdtClick(){
            this.isSdt = !this.isSdt;
            this.isMore = false;
        },
        footTab(idx){
            this.footIdx = idx;
            this.page = 1;
            this.content = '';
            this.historyDeal = [];
            this.klineTrade = [];
            if(idx == 0){
                this.getHistoryDeal();
            }else if(idx == 1){
                this.getklineTrade();
                this.isNoData = false;
            }else{
                this.getChainData();
                this.isNoData = false;
            }

        },
        buy(id){
            this.$router.push({name:'transaction',query:{buy:id}});
        },
        payJump(){
            this.isPay = false;
            this.isMask = false;
            this.$router.push('/ModifyCashPwd');
        },
        sureBuy(){
            if(this.amount == '' || this.amount == null){
                this.$toast.bottom(this.$t('duihuang.qtxje'));
                return false;
            }
            if(this.tradeType == 1){
                if(this.amount > parseFloat(this.curCurrency)){
                    this.$toast.bottom(this.$t('duihuang.yebz'));
                    return false;
                }
            }else{
                if(this.amount > parseFloat(this.currency_money)){
                    this.$toast.bottom(this.$t('duihuang.ksslbz'));
                    return false;
                }

            }
            this.isShow = true;
        },
        getMemberInfo(){
            let params = {
                uid: this.uid,
                token: this.token
            }
            this.$ajax.post('/api/member/getMemberInfo',params).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 200){
                    this.curMoney = resData.btcm_money;
                    this.btc_money = resData.btc_money;
                    this.btcm_money = resData.btcm_money;
                    this.eth_money = resData.eth_money;
                    this.usdt_money = resData.usdt_money;
                    this.trx_money = resData.trx_money || '0.0000';
                }else{
                    this.$toast.bottom(res.data.msg);
                }
            }).catch(function(err){
                console.log(err);
            })
        },
        getNewestcurrency(){
            let params = {
                uid: this.uid,
                token: this.token
            }
            this.$ajax.post('/api/miningmachine/newestcurrency',params).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 200){
                    this.btcm = resData.local_currency;
                    this.btc = resData.btc;
                    this.eth = resData.eth;
                    this.trx = resData.trx;
                    this.getCurrency();
                }else if(res.data.code == 20001){
                    this.$router.push('/login');
                }else{
                    this.$toast.bottom(res.data.msg);
                }
            }).catch(function(err){
                console.log(err);
            })
        },
        getCurrency(){
            if(this.currency == 'BTC'){
                this.currency1 = this.btc;
                this.currency_money = this.btc_money
            }else if(this.currency == 'GDCC'){
                this.currency1 = this.btcm;
                this.currency_money = this.btcm_money;
            }else if(this.currency == 'ETH'){
                this.currency1 = this.eth;
                this.currency_money = this.eth_money;
            }else if(this.currency == 'USDT'){
                this.currency1 = this.usdt;
                this.currency_money = this.usdt_money;
            }else if(this.currency == 'TRX'){
                this.currency1 = this.trx;
                this.currency_money = this.trx_money;
            }else{
                 this.currency1 = this.usdt;
                 this.currency_money = this.usdt_money;
            }
            if(this.tradeType == 1){
                this.curCurrency = (parseFloat(this.usdt_money)/(parseFloat(this.currency1) * (1 + parseFloat(this.chainData.buy_rate)/100))).toFixed(4);
            }else{
                this.curCurrency = (parseFloat(this.currency_money)*(parseFloat(this.currency1) * (1 - parseFloat(this.chainData.sell_rate)/100))).toFixed(4);
            }
        },
        check(){//检测是否设置提现密码
            let params = {
                uid: this.uid,
                token: this.token
            }
            this.$ajax.post('/api/Member/checkMoneyPass',params).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 200){
                    this.isPay = false;
                }else{
                    this.isPay = true;
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        nextFocus(el,index) {
            var dom = document.getElementsByClassName("pwd-input"),
                currInput = dom[index],
                nextInput = dom[index + 1],
                lastInput = dom[index - 1];
            /*这里的keyCode 根据不同的平台或许不同,安卓就是不是8*/
            if (el.keyCode != 8) {
                if (index < (this.inputList.length - 1)) {
                    nextInput.focus();
                } else {
                    currInput.blur();
                }
            }else{
                if (index != 0) {
                    lastInput.focus();
                }
            }
            let password = this.inputList[0].val +  this.inputList[1].val + this.inputList[2].val + this.inputList[3].val +  this.inputList[4].val + this.inputList[5].val;
            if(password.length == 6){
                let params = {
                    uid: this.uid,
                    token: this.token,
                    currency_type: this.currency_type,
                    currency_way: this.tradeType,
                    money: this.amount,
                    money_password: password,
                }
                this.$ajax.post('/api/Klineview/currencyExchangeNew',params).then((res) => {
                    let resData = res.data.data;
                    if(res.data.code == 200){
                        this.isBuy = false;
                        this.isMask = false;
                        this.isShow = false;
                        this.page = 1;
                        this.historyDeal = [];
                        this.klineTrade = [];
                        if(this.tradeType == 1){
                            this.$toast.bottom(this.$t('duihuang.wtcg'));
                            this.getHistoryDeal();
                            this.getklineTrade();
                        }else{
                            this.$toast.bottom(this.$t('duihuang.wtcg'));
                            this.getHistoryDeal();
                            this.getklineTrade();
                        }
                        this.inputList =  [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
                        this.getMemberInfo();
                    }else if(res.data.code == 40016){
                        this.isMask = true;
                        this.isShow2 = true;
                        this.btcmTips = res.data.msg;
                    }else if(res.data.code == 40006){
                        this.isMask = true;
                        this.isShow = true;
                        this.$toast.bottom(res.data.msg);
                        this.inputList =  [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
                    }else{
                        this.isMask = false;
                        this.isShow = false;
                        this.$toast.bottom(res.data.msg);
                        this.inputList =  [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
                    }
                }).catch(function(err){
                    console.log(err);
                })
            }else{
                return false;
            }
        },
        keyAmount(){
            this.amount = this.amount.replace(/[^\d.]/g, "");  //仅保留数字和"."
			this.amount = this.amount.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
			this.amount = this.amount.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
			this.amount = this.amount.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
			if (this.amount.indexOf(".") < 0 && this.amount != "") { //首位是0的话去掉
				this.amount = parseFloat(this.amount);
			}
		},
        tab(idx,type,kvalue,ktype){
            this.websock.close();
            clearInterval(this.timer2);
            this.timer2 = null;
            this.initWebSocket();
            this.createWidget();
            this.timeType = type;
            this.tabIdx = idx;
            this.isMore = false;
            this.timeIdx = 5;
            localStorage.setItem('time_type',type)
            localStorage.setItem('tim', kvalue)
            localStorage.setItem('type', ktype)
            this.klineHistoryList();
        },
        timeClick(idx,type,kvalue,ktype){
            this.websock.close();
            clearInterval(this.timer2);
            this.timer2 = null;
            this.initWebSocket();
            this.createWidget();
            this.timeType = type;
            this.timeIdx = idx;
            this.isMore = false;
            this.tabIdx = 5;
            localStorage.setItem('time_type',type);
            localStorage.setItem('tim', kvalue)
            localStorage.setItem('type', ktype)
            this.klineHistoryList();
        },
        // 滚动到页面顶部
        scrollTo() {
             $('.position-box').animate({scrollTop:'0px'},'slow');
        },
        listenScroll(e) {  //监听滚动
            let ele = e.srcElement ? e.srcElement : e.target;
            if(ele.scrollTop > 100){
                this.isTop = true
            }else{
                this.isTop = false
            }
            if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
                if(this.curDataLength > 0){
                    this.page ++;
                    this.getHistoryDeal();
                }
            }
        },
        contHtml(str){
            str = str.replace(/&amp;/g, '&');
            str = str.replace(/&lt;/g, '<');
            str = str.replace(/&gt;/g, '>');
            str = str.replace(/&quot;/g, "''");
            str = str.replace(/&#039;/g, "'");
            return str;
        },
        close(){
            this.isShow2 = false;
            this.isBuy = false;
            this.isMask = false;
        },
        close2(){
            this.isShow = false;
        },
        goBack(){
            this.$router.push({name:'transaction',query:{buy:this.tradeType}});
        },
        connect(real) { //封装推送数据
            vm.timer2 = setInterval(()=>{
                var msg = vm.klineData;
                var times = vm.curTimeTap;
                if(msg.type == 'kline'){
                    msg.open = parseFloat(msg.open)
                    msg.close = parseFloat(msg.close);
                    msg.low = parseFloat(msg.low)
                    msg.high = parseFloat(msg.high)
                    msg.volume = parseFloat(msg.volume);
                    msg.time = Number(Number(times)*1000);
                    if(vm.prevData && vm.prevData[0] && msg.time < Number(vm.prevData[0].time)){
                        vm.prevData.push(JSON.parse(JSON.stringify(msg)))
                        if(vm.prevData.length>2)vm.prevData.shift()
                        return
                    }
                    if(vm.prevData && vm.prevData[0] && msg.time > Number(vm.prevData[0].time)){
                        vm.prevData[0].close = vm.prevData[0].realclose
                        vm.prevData[0].close = Number(vm.prevData[0].close)
                        real(vm.prevData[0]);
                    }
                    if(vm.prevData.length>2)vm.prevData.shift();
                    real(msg)
                }
            },2000);
        },
        createWidget() {
            var _this = this;
            this.$nextTick(function () {
                var local = _this.lang;
                var widget = _this.widget = new TradingView.widget({
                    symbol: _this.symbol,
                    interval: '1',
                    debug: false,
                    fullscreen: false,
                    autosize: true,
                    container_id: "tv_chart_container",
                    datafeed: _this.createFeed(),
                    library_path: "static/js/tradeview/charting_library/",
                    custom_css_url: 'bundles/new.css',
                    locale: 'en' ,// || 'en';"zh",
                    width: "100%",
                    height: '400px',
                    theme: 'Light',
                    toolbar_bg:'#ffffff',//工具栏背景颜色
                    loading_screen:{backgroundColor:'#eee',foregroundColor:'#eee'},
                    drawings_access: {
                        type: 'white',
                        tools: [{
                            name: "Regression Trend"
                        }]
                    },
                    disabled_features: [ //  禁用的功能
                        'left_toolbar', 'widget_logo', 'header_saveload', 'compare_symbol', 'display_market_status',
                        'go_to_date', 'header_chart_type', 'header_compare', 'header_interval_dialog_button',
                        'header_resolutions', 'header_screenshot', 'header_symbol_search', 'header_undo_redo',
                        'legend_context_menu', 'show_hide_button_in_legend', 'show_interval_dialog_on_key_press',
                        'snapshot_trading_drawings', 'symbol_info', 'timeframes_toolbar', 'use_localstorage_for_settings',
                        'volume_force_overlay','main_series_scale_menu','chart_zoom'
                    ],
                    enabled_features: [ //  启用的功能（备注：disable_resolution_rebuild 功能用于控制当时间范围为1个月时，日期刻度是否都是每个月1号
                        'dont_show_boolean_study_arguments', 'hide_last_na_study_output', 'move_logo_to_main_pane',
                        'same_data_requery', 'side_toolbar_in_fullscreen_mode', 'disable_resolution_rebuild'
                    ],
                    charts_storage_api_version: "1.1",
                    toolbar_bg: "transparent",
                    timezone: "Asia/Shanghai",

                    studies_overrides: {//#00c483 #d14b65
                        "volume.volume.color.0": "rgba(250, 77, 86,.7)",
                        "volume.volume.color.1": "rgba(0, 180, 100,.8)",
                        "volume.volume.transparency": 75,    //透明度
                    },
                    overrides: _this.overrides()
                });

                widget.MAStudies = [];
                widget.selectedIntervalButton = null;

                widget.onChartReady(function () { //图表方法
                    widget.MALine7 = widget.chart().createStudy("Moving Average Exponential", false, false, [5], null, {
                        "plot.color": "#EB4D5C",
                        "plot.linewidth": 2
                    });
                    widget.MALine15 = widget.chart().createStudy("Moving Average Exponential", false, false, [10], null, {
                            "plot.color": "#13B887",
                            "plot.linewidth": 2
                    });
                    widget.MALine30 = widget.chart().createStudy("Moving Average Exponential", false, false, [30], null, {
                        "plot.color": "#cf30af",
                        "plot.linewidth": 2
                    });
                    let buttonArr = [
                        {
                            value: "1",
                            period: "1m",
                            text: "1min",
                            chartType: 1,
                            type: "1min"
                        },
                        {
                            value: "5",
                            period: "5m",
                            text: "5min",
                            chartType: 1,
                            type: "5min"
                        },
                        {
                            value: "15",
                            period: "15m",
                            text: "15min",
                            chartType: 1,
                            type: "15min"
                        },
                        {
                            value: "30",
                            period: "30m",
                            text: "30min",
                            chartType: 1,
                            type: "30min"
                        },
                        {
                            value: "60",
                            period: "60分钟",
                            text: "1hour",
                            chartType: 1,
                            type: "60min"
                        },
                        {
                            value: "1D",
                            period: "1D",
                            text: "1day",
                            chartType: 1,
                            type: "1day"
                        },
                        {
                            value: "1W",
                            period: "1W",
                            text: "1week",
                            chartType: 1,
                            type: "1week"
                        },
                        {
                            value: "1M",
                            period: "1M",
                            text: "1mon",
                            chartType: 1,
                            type: "1mon"
                        },
                    ];
                    let btn = {};
                    let nowTime = '';

                    if(!localStorage.getItem('tim')){
                        localStorage.setItem('tim', '2') //默认为1分钟
                        localStorage.setItem('type','1min')  //默认为1分钟
                    }

                    $('#fullScreen').click(function(){
                        var screenH = $('body').height();
                        $("iframe").contents().find("body").find('.fullscreen').trigger('click');
                    })
                    $(document).on('click','.info-foot .item-box .time,.alert-sdt-box .alert-more-list .text',function(){
                        var kvalue = $(this).attr('data-val');
                        var ktype = $(this).attr('data-type');
                        var chartType = $(this).attr('data-chartType');
                        widget.chart().setChartType(1); //改变K线类型
                        _this.$nextTick(function(){
                            handleClick(kvalue,ktype);
                        })

                    })
                    var handleClick = (kvalue,ktype) => {
                        _this.setSymbol = function (symbol, kvalue) {
                            gh.chart().setSymbol(symbol, kvalue);
                        };
                        localStorage.setItem('tim', kvalue)
                        localStorage.setItem('type', ktype)
                        widget.chart().setResolution(kvalue, function onReadyCallback() {}); //改变分辨率
                    };

                });

                _this.widget = widget;
            })
        },
        createFeed() {
            let this_vue = this;
            let Datafeed = {};

            Datafeed.DataPulseUpdater = function (datafeed, updateFrequency) {
                this._datafeed = datafeed;
                this._subscribers = {};

                this._requestsPending = 0;
                var that = this;

                var update = function () {
                    if (that._requestsPending > 0) {
                        return;
                    }

                    for (var listenerGUID in that._subscribers) {
                        var subscriptionRecord = that._subscribers[listenerGUID];
                        var resolution = subscriptionRecord.resolution;

                        var datesRangeRight = parseInt((new Date().valueOf()) / 1000);


                        //	BEWARE: please note we really need 2 bars, not the only last one
                        //	see the explanation below. `10` is the `large enough` value to work around holidays
                        var datesRangeLeft = datesRangeRight - that.periodLengthSeconds(resolution, 10);

                        that._requestsPending++;

                        (function (_subscriptionRecord) { // eslint-disable-line
                            that._datafeed.getBars(_subscriptionRecord.symbolInfo, resolution, datesRangeLeft, datesRangeRight,
                                function (bars) {
                                    that._requestsPending--;

                                    //	means the subscription was cancelled while waiting for data
                                    if (!that._subscribers.hasOwnProperty(listenerGUID)) {
                                        return;
                                    }

                                    if (bars.length === 0) {
                                        return;
                                    }

                                    var lastBar = bars[bars.length - 1];
                                    if (!isNaN(_subscriptionRecord.lastBarTime) && lastBar.time < _subscriptionRecord.lastBarTime) {
                                        return;
                                    }

                                    var subscribers = _subscriptionRecord.listeners;

                                    //	BEWARE: this one isn't working when first update comes and this update makes a new bar. In this case
                                    //	_subscriptionRecord.lastBarTime = NaN
                                    var isNewBar = !isNaN(_subscriptionRecord.lastBarTime) && lastBar.time > _subscriptionRecord.lastBarTime;

                                    //	Pulse updating may miss some trades data (ie, if pulse period = 10 secods and new bar is started 5 seconds later after the last update, the
                                    //	old bar's last 5 seconds trades will be lost). Thus, at fist we should broadcast old bar updates when it's ready.
                                    if (isNewBar) {
                                        if (bars.length < 2) {
                                            throw new Error('Not enough bars in history for proper pulse update. Need at least 2.');
                                        }

                                        var previousBar = bars[bars.length - 2];
                                        for (var i = 0; i < subscribers.length; ++i) {
                                            subscribers[i](previousBar);
                                        }
                                    }

                                    _subscriptionRecord.lastBarTime = lastBar.time;

                                    for (var i = 0; i < subscribers.length; ++i) {
                                        subscribers[i](lastBar);
                                    }
                                },

                                //	on error
                                function () {
                                    that._requestsPending--;
                                });
                        })(subscriptionRecord);
                    }
                };

                if (typeof updateFrequency != 'undefined' && updateFrequency > 0) {
                    setInterval(update, updateFrequency);
                }
            };

            Datafeed.DataPulseUpdater.prototype.periodLengthSeconds = function (resolution, requiredPeriodsCount) {
                var daysCount = 0;

                if (resolution === 'D') {
                    daysCount = requiredPeriodsCount;
                } else if (resolution === 'M') {
                    daysCount = 31 * requiredPeriodsCount;
                } else if (resolution === 'W') {
                    daysCount = 7 * requiredPeriodsCount;
                } else {
                    daysCount = requiredPeriodsCount * resolution / (24 * 60);
                }
                return daysCount * 24 * 60 * 60;
            };

            Datafeed.DataPulseUpdater.prototype.subscribeDataListener = function (symbolInfo, resolution, newDataCallback,
                                                                                  listenerGUID) {
                this._datafeed._logMessage('Subscribing ' + listenerGUID);

                if (!this._subscribers.hasOwnProperty(listenerGUID)) {
                    this._subscribers[listenerGUID] = {
                        symbolInfo: symbolInfo,
                        resolution: resolution,
                        lastBarTime: NaN,
                        listeners: []
                    };
                }

                this._subscribers[listenerGUID].listeners.push(newDataCallback);
            };

            Datafeed.DataPulseUpdater.prototype.unsubscribeDataListener = function (listenerGUID) {
                this._datafeed._logMessage('Unsubscribing ' + listenerGUID);
                delete this._subscribers[listenerGUID];
            };

            Datafeed.Container = function (updateFrequency) {
                this._configuration = {
                    supports_search: false,
                    supports_group_request: false,
                    supported_resolutions: ['1', '5', '15', '30', '60','240','1D', '1W','1M'],
                    supports_marks: true,
                    supports_timescale_marks: true,
                    exchanges: ['gh']
                };

                this._barsPulseUpdater = new Datafeed.DataPulseUpdater(this, updateFrequency || 10 * 1000);

                this._enableLogging = true;
                this._callbacks = {};

                this._initializationFinished = true;
                this._fireEvent('initialized');
                this._fireEvent('configuration_ready');
            };

            Datafeed.Container.prototype._fireEvent = function (event, argument) {
                if (this._callbacks.hasOwnProperty(event)) {
                    var callbacksChain = this._callbacks[event];
                    for (var i = 0; i < callbacksChain.length; ++i) {
                        callbacksChain[i](argument);
                    }

                    this._callbacks[event] = [];
                }
            };

            Datafeed.Container.prototype._logMessage = function (message) {
                if (this._enableLogging) {
                    var now = new Date();
                    console.log("CHART LOGS: " + now.toLocaleTimeString() + '.' + now.getMilliseconds() + '> ' + message);
                }
            };

            Datafeed.Container.prototype.on = function (event, callback) {
                if (!this._callbacks.hasOwnProperty(event)) {
                    this._callbacks[event] = [];
                }

                this._callbacks[event].push(callback);
                return this;
            };

            Datafeed.Container.prototype.onReady = function (callback) {
                let that = this;
                if (this._configuration) {
                    setTimeout(function () {
                        callback(that._configuration);
                    }, 0);
                } else {
                    this.on('configuration_ready', function () {
                        callback(that._configuration);
                    });
                }
            };

            Datafeed.Container.prototype.resolveSymbol = function (symbolName, onSymbolResolvedCallback,
                                                                   onResolveErrorCallback) {
                this._logMessage("GOWNO :: resolve symbol " + symbolName);
                Promise.resolve().then(() => {
                    onSymbolResolvedCallback({
                        "name": this_vue.symbol,
                        "timezone": "Asia/Shanghai",
                        "pricescale": this_vue.priceScale,
                        "PriceScaleMode": this_vue.PriceScaleMode,
                        "minmov": 1, //minmov(最小波动), pricescale(价格精度), minmove2, fractional(分数)
                        "minmov2": 0, //这是一个神奇的数字来格式化复杂情况下的价格。
                        "ticker": this_vue.symbol,
                        "description": "",
                        "type": "bitcoin",
                        "volume_precision": 8,
                        //现在，这两个字段都为某个交易所的略称。将被显示在图表的图例中，以表示此商品。目前此字段不用于其他目的。
                        "has_intraday": true,
                        "has_weekly_and_monthly": true,
                        "has_no_volume": false, //布尔表示商品是否拥有成交量数据。
                        'session': '24x7',
                        'supported_resolutions': ['1', '5', '15', '30', '60','240','1D', '1W','1M']

                    });
                })
            };
            var url = this.klineHistoryUrl();
            //初始化数据
            Datafeed.Container.prototype.getBars = function (symbolInfo, resolution, rangeStartDate, rangeEndDate,
                                                             onHistoryCallback, onErrorCallback) {
                if (resolution.indexOf('D') == -1 && resolution.indexOf('W') == -1 && resolution.indexOf('M') == -1) {
                    resolution = resolution + 'min'
                } else if (resolution.indexOf('W') != -1 || resolution.indexOf('M') != -1) {
                    resolution = resolution
                }
                var _this = this;
                var uid = localStorage.getItem('uid');
                var token = localStorage.getItem('token');
                var timeType = localStorage.getItem('time_type') || 2;
                var currency_type = localStorage.getItem('currency_type') || 1;
                var params = {
                    uid: uid,
                    token: token,
                    limit: 1000,
                    page: 1,
                    time_type: timeType,
                    currency_type: currency_type
                }
                $.ajax({
                    url: url,
                    data: params,
                    type: 'post',
                    success: function (res) {
                        var res = JSON.parse(res);
                        if (res&& res.data && res.data.length > 0) {
                            res.data.forEach((item, i) => {
                                item.time = Number(item.create_date*1000)
                                item.open = Number(item.open)
                                item.close = Number(item.close)
                                item.high = Number(item.high)
                                item.low = Number(item.low)
                                item.volume = Number(item.volume)
                            })

                            onHistoryCallback(res.data.reverse(), {
                                noData: false
                            })
                            onHistoryCallback([], {
                                noData: true
                            })

                        }
                        if (!res.data) {
                            onHistoryCallback([], {
                                noData: true
                            })
                        }
                        if (res.data && res.data.length == 0) {
                            onHistoryCallback([], {
                                noData: true
                            })
                        }

                    }
                })
            };
            //实时数据
            Datafeed.Container.prototype.subscribeBars = function (symbolInfo, resolution, onRealtimeCallback, listenerGUID,
                                                                   onResetCacheNeededCallback) {
                this_vue.connect(onRealtimeCallback)

                //this._barsPulseUpdater.subscribeDataListener(symbolInfo, resolution, onRealtimeCallback, listenerGUID, onResetCacheNeededCallback);
            };

            Datafeed.Container.prototype.unsubscribeBars = function (listenerGUID) {

                this._barsPulseUpdater.unsubscribeDataListener(listenerGUID);

            };

            return new Datafeed.Container;
        },

        updateWidget(item) {
            vm.symbolInfo = {
                name: item,
                ticker: item,
                description: "",
                session: "24x7",
                supported_resolutions: ['1', '5', '30', '60', '240', '1D', '3D', '1W', '1M'],
                has_intraday: true,
                has_daily: true,
                has_weekly_and_monthly: true,
                timezone: "GDCC",
            }

            vm.removeWidget();
            vm.createWidget();
        },
        removeWidget() {
            if (vm.widget) {
                vm.widget.remove();
                vm.widget = null;
            }
        },
        overrides() {
            let style = {
                up: "#00B464",
                down: "#FA4D56",
                bg: "#0f1827",
                grid: "#1E2740",
                cross: "#1E2740",
                border: "#1a293b",
                text: "#6682a1",
                areatop: "#00B464",
                areadown: "#FA4D56"
            };
            return {
                'volumePaneSize': "medium", //large, medium, small, tiny
                'paneProperties.topMargin': '20',
                "scalesProperties.lineColor": style.bg,
                "scalesProperties.textColor": style.text,
                "paneProperties.background": style.bg, //改变背景色的重要代码
                "paneProperties.vertGridProperties.color": style.grid,
                "paneProperties.horzGridProperties.color": style.grid,
                "paneProperties.crossHairProperties.color": style.cross,
                "paneProperties.legendProperties.showLegend": true,
                "paneProperties.legendProperties.showStudyArguments": true,
                "paneProperties.legendProperties.showStudyTitles": true,
                "paneProperties.legendProperties.showStudyValues": true,
                "paneProperties.legendProperties.showSeriesTitle": true,
                "paneProperties.legendProperties.showSeriesOHLC": true,
                "mainSeriesProperties.candleStyle.upColor": style.up,
                "mainSeriesProperties.candleStyle.downColor": style.down,
                "mainSeriesProperties.candleStyle.drawWick": true,
                "mainSeriesProperties.candleStyle.drawBorder": true,
                "mainSeriesProperties.candleStyle.borderColor": style.border,
                "mainSeriesProperties.candleStyle.borderUpColor": style.up,
                "mainSeriesProperties.candleStyle.borderDownColor": style.down,
                "mainSeriesProperties.candleStyle.wickUpColor": style.up,
                "mainSeriesProperties.candleStyle.wickDownColor": style.down,
                "mainSeriesProperties.candleStyle.barColorsOnPrevClose": false,
                "mainSeriesProperties.hollowCandleStyle.upColor": style.up,
                "mainSeriesProperties.hollowCandleStyle.downColor": style.down,

                "mainSeriesProperties.hollowCandleStyle.drawWick": true,
                "mainSeriesProperties.hollowCandleStyle.drawBorder": true,
                "mainSeriesProperties.hollowCandleStyle.borderColor": style.border,
                "mainSeriesProperties.hollowCandleStyle.borderUpColor": style.up,
                "mainSeriesProperties.hollowCandleStyle.borderDownColor": style.down,
                "mainSeriesProperties.hollowCandleStyle.wickColor": style.line,
                "mainSeriesProperties.haStyle.upColor": style.up,
                "mainSeriesProperties.haStyle.downColor": style.down,
                "mainSeriesProperties.haStyle.drawWick": true,
                "mainSeriesProperties.haStyle.drawBorder": true,
                "mainSeriesProperties.haStyle.borderColor": style.border,
                "mainSeriesProperties.haStyle.borderUpColor": style.up,
                "mainSeriesProperties.haStyle.borderDownColor": style.down,
                "mainSeriesProperties.haStyle.wickColor": style.border,
                "mainSeriesProperties.haStyle.barColorsOnPrevClose": false,
                "mainSeriesProperties.barStyle.upColor": style.up,
                "mainSeriesProperties.barStyle.downColor": style.down,
                "mainSeriesProperties.barStyle.barColorsOnPrevClose": false,
                "mainSeriesProperties.barStyle.dontDrawOpen": false,
                "mainSeriesProperties.lineStyle.color": style.border,
                "mainSeriesProperties.lineStyle.linewidth": 1,
                "mainSeriesProperties.lineStyle.priceSource": "close",
                "mainSeriesProperties.areaStyle.color1": style.areatop,
                "mainSeriesProperties.areaStyle.color2": style.areadown,
                "mainSeriesProperties.areaStyle.linecolor": style.border,
                "mainSeriesProperties.areaStyle.linewidth": 1,
                "mainSeriesProperties.areaStyle.priceSource": "close"
            }
        }
    },
    sockets: {},
    filters:{
        toFixed2: function (value) {
            value = Number(value);
            return value.toFixed(3);
        },
        toFixed4: function (value, options) {
            if(value){
                value = Number(value);
                return value.toFixed(4);
            }else{
                return ''
            }
        },
        sellType: function(val){
            var value = Number(val);
            if(value == 1){
                return vm.mr;
            }else{
                return vm.mc;
            }
        },
        statusText: function(val){
            var value = Number(val);
            if(value == 2){
                return vm.$t('kxt.ycj');
            }else{
                return vm.$t('kxt.wtcd');
            }
        },
        timeTamp: function(timess){
            var date = new Date((timess - that.timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
            var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
            var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            return Y + M + D + " " + h + m + s;
        },
        timeTamp2: function (timess) {
            var date = new Date(timess - that.timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            var D = date.getDate() > 9 ? date.getDate() + ' ' : ('0' + date.getDate()) + ' ';
            var h = date.getHours() > 9 ? date.getHours() + ':' : ('0' + date.getHours()) + ':';
            var m = date.getMinutes() > 9 ? date.getMinutes() + ':' : ('0' + date.getMinutes()) + ':';
            var s = date.getSeconds() > 9 ? date.getSeconds() : ('0' + date.getSeconds());
            return Y + M + D + h + m + s;
        }
    },
    computed: {
        listenState() { //监听交易对
            return this.symbol;
        }
    },
    watch: {
        xianjia: function(val){
            var amount = this.amount || 0;
            var xianjia = parseFloat(val)
            if(val > 0){
                if(this.tradeType == 1){
                    this.totalMoney = (parseFloat(amount) * parseFloat(xianjia) * (1 + parseFloat(this.chainData.buy_rate)/100)).toFixed(4)
                }else{
                   this.totalMoney = (parseFloat(amount) * parseFloat(xianjia) * (1 - parseFloat(this.chainData.sell_rate)/100)).toFixed(4)
                }
            }else{
                this.totalMoney = 0.0000;
            }
        },
        amount: function(val){
            var amount = val;
            var xianjia = this.xianjia
            if(val > 0){
                if(this.tradeType == 1){
                    this.totalMoney = (parseFloat(amount) * parseFloat(xianjia) * (1 + parseFloat(this.chainData.buy_rate)/100)).toFixed(4)
                }else{
                   this.totalMoney = (parseFloat(amount) * parseFloat(xianjia) * (1 - parseFloat(this.chainData.sell_rate)/100)).toFixed(4)
                }
            }else{
                this.totalMoney = 0.0000;
            }
        },
        listenState: function (a, b) { //监听交易对
            if (a != b && b != '') {
                this.widget.setSymbol(a, localStorage.getItem('tim'), function onReadyCallback() {}) //切换币种
            }
        },
    },
    components:{
        noData,
        loading
    },
    beforeDestroy(){
        localStorage.removeItem('reloaded');
        clearInterval(vm.timer);
        clearInterval(vm.timer2);
        clearInterval(vm.timer3);
        clearInterval(vm.timerTimes);
        vm.timer = null;
        vm.timer2 = null;
        vm.timer3 = null;
        vm.timerTimes = null;
        vm.websock.close(); //离开路由之后断开websocket连接
        localStorage.removeItem('currency_type');
        localStorage.removeItem('time_type')
    },
    destroyed() {
        vm.removeWidget();
        vm.websock.close() //离开路由之后断开websocket连接
    }
}
</script>
<style scoped>
    input::-webkit-input-placeholder{
        color: #919191;
        font-size: .28rem;
    }
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: auto;
    }
    .scroll-box{
        overflow: auto;
        padding-bottom: 1rem;
    }
    .kline-head{
        position: fixed;
        top: 0;
        z-index: 101;
        display: flex;
        align-items: center;
        width: 100%;
        height: .6rem;
        padding: 0 .28rem;
        color: #fff;
        font-size: .32rem;
        line-height: .6rem;
        background: #131e30;
        box-sizing: border-box;
    }
    .kline-head .icon{
        margin-right: .3rem;
        width: .24rem;
        height: .44rem;
    }
    .kline-head .kline-left{
        display: flex;
        flex: 1;
        align-items: center;
    }
    .kline-head .btn-alert{
        width: .4rem;
        height: .4rem;
        margin-right: .3rem;
    }
    .kline-head .kline-right .btn{
        width: .36rem;
        height: .36rem;
    }
    .kline-head .kline-right .btn-qp{
        margin-left: .36rem;
    }
    .info-box{
        position: relative;
        margin-top: .6rem;
        padding: .04rem .28rem;
        background: #131e30;
    }
    .info-box .info-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .info-box .info-head .info-left{
        text-align: left;
    }
    .info-box .info-head .info-left .price{
        color: #00B464;
        font-size: .36rem;
        font-weight: bold;
    }
    .info-box .info-head .info-left .t1{
        margin-top: .16rem;
        color: #7286a7;
    }
    .info-box .info-head .info-left .t1 span{
        color: #00B464;
        font-size: .28rem;
    }
    .info-box .info-head .info-right .item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 2px;
        color: #7286a7;
        font-size: .26rem;
    }
    .info-box .info-head .info-right .num{
        margin-left: .2rem;
        color: #fff;
    }
    .info-box .info-foot{
        position: absolute;
        width: 70%;
    }
    .info-box .item-box{
        position: relative;
        z-index: 100;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .24rem 0 .2rem;
        color: #7286a7;
        font-size: .24rem;
    }
    .info-box .item-box .item .icon{
        width: .5rem;
        height: .5rem;
    }
    .info-box .item-box .item.more{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .info-box .item-box .item .down{
        width: .2rem;
        height: .2rem;
    }
    .info-box .item-box .item{
        position: relative;
    }
    .info-box .item-box .item.active{
        color: #218adc;
    }
    .info-box .item-box .item.moreActive{
        color: #218adc;
    }
    .info-box .item-box .item.active::after{
        position: absolute;
        left: 0;
        bottom: -.12rem;
        content: '';
        width: 100%;
        height: 2px;
        border-radius: .2rem;
        background: #218adc;
    }
    .info-box .alert-sdt-box{
        position: absolute;
        left: -6px;
        right: 6px;
        top: .84rem;
        width: 120%;
        padding: .28rem .32rem .28rem .24rem;
        border: 1px solid #4f4f4f;
        border-radius: 4px;
        background: #131e30;
        box-sizing: border-box;
    }
    .info-box .alert-sdt-box .alert-sdt-list{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .info-box .alert-sdt-box .alert-sdt-list:last-child{
        margin-top: .28rem;
    }
    .info-box .alert-sdt-box .alert-sdt-list .text{
        padding-right: .28rem;
        color: #fff;
    }
    .info-box .alert-sdt-box .alert-sdt-info{
        display: flex;
        flex: 1;
        align-items: center;
        padding: 0 .2rem;
        border-left: 1px solid #526270;
    }
    .info-box .alert-sdt-box .alert-sdt-info .info-text{
        width: .9rem;
    }
    .info-box .alert-sdt-box .alert-sdt-info .active{
        color: #fff;
    }
    .info-box .alert-sdt-box .alert-sdt-list .icon{
        width: .44rem;
        height: .32rem;
    }
    .info-box .alert-sdt-box .alert-more-list{
        display: flex;
        align-items: center;
    }
    .info-box .alert-sdt-box .alert-more-list .text{
        flex: 1;
        border-right: 1px solid #7286a7;
        text-align: center;
    }
    .info-box .alert-sdt-box .alert-more-list .text:last-child{
        border-right: none;
    }
    .info-box .alert-sdt-box .alert-more-list .active{
        color: #fff;
    }
    .cont-box{
        padding: 0 0 .2rem;
        background: #131E30;
    }
    .cont-box .tab-box{
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: .1rem 0 .26rem;
        color: #fff;
        font-size: .3rem;
        background: #162335;
    }
    .cont-box .tab-box .tab{
        position: relative;
        font-size: .26rem;
    }
    .cont-box .tab-box .tab.active{
        font-size: .3rem;
    }
    .cont-box .tab-box .tab.active::after{
        position: absolute;
        left: 50%;
        bottom: -.12rem;
        content: '';
        width: .4rem;
        height: 2px;
        margin-left: -.2rem;
        background: #218adc;
    }
    .cont-box .item0-box{
        padding: 0 0 .36rem;
        color: #3d536e;
    }
    .cont-box .item0-box .table-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: .36rem;
        font-size: .24rem;
    }
    .cont-box .item0-box .ul-box{
        display: flex;
        align-items: stretch;
        overflow-x: auto;
    }
    .cont-box .item0-box .ul-box .list{
        flex: 1;
        height: inherit!important;
    }
    .cont-box .item0-box .ul-box .list .ul{
        width: 100%;
        padding-right: 2px;
    }
    .cont-box .item0-box .ul-box .list .item{
        position: relative;
        z-index: 2;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .cont-box .item0-box .w1{
        width: .48rem;
    }
    .cont-box .item0-box .w2{
        width: 1.6rem;
        text-align: center;
    }
    .cont-box .item0-box .w3{
        width: 1.56rem;
        color: #00B464;
        padding-right: .2rem;
        text-align: right;
    }
    .cont-box .item0-box .scroll{
        position: absolute;
        right: 0;
        z-index: -1;
        width: 0%;
        height: .6rem;
        background: #132b36;
    }
    .cont-box .item0-box .scroll2{
        position: absolute;
        left: 0;
        z-index: -1;
        width: 0%;
        height: .6rem;
        background: #232435;
    }
    .cont-box .item0-box .w4{
        width: 1.84rem;
        padding-left: .2rem;
        color: #FA4D56;
    }
    .cont-box .item0-box .w5{
        width: 1.6rem;
        text-align: center;
    }
    .cont-box .item0-box .w6{
        /* width: 24px; */
        text-align: right;
    }
    .cont-box .item0-box .w7{
        width: 3.44rem;
        text-align: center;
    }
    .cont-box .item0-box .ul-box .list{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: .6rem;
        margin-bottom: .08rem;
        line-height: .6rem;
        color: #7286a7;
    }
    .cont-box .item1-box .table-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .2rem 0;
        color: #7286a7;
        font-size: .28rem;
    }
    .cont-box .item1-box .table-head .th,.cont-box .item1-box .table-body .td{
        flex: 1;
        font-size: .24rem;
        text-align: center;
    }
    .cont-box .item1-box .table-body .table-tr{
        margin-top: .1rem;
        padding: .2rem;
        color: #e2e2e2;
        font-size: .26rem;
        background: #162335;
    }
    .cont-box .item1-box .table-body .trade-box{
        display: flex;
    }
    .cont-box .item1-box .table-body .time-box{
        display: flex;
        align-items: center;
    }
    .cont-box .item1-box .table-body .type{
        display: inline-block;
        padding: .02rem .06rem;
        color: #fff;
        font-size: .24rem;
        border-radius: .04rem;
    }
    .cont-box .item1-box .table-body .type.mr{
        background: #00B464;
    }
    .cont-box .item1-box .table-body .type.mc{
        background: #FA4D56;
    }
    .cont-box .item1-box .table-body .td.mr{
        color: #00B464;
    }
    .cont-box .item1-box .table-body .td.mc{
        color: #FA4D56;
    }
    .cont-box .item1-box .table-body .text{
        flex: 1;
        padding: 0 .1rem;
     }
    .cont-box .table-body .status{
        margin-left: .3rem;
        color: #2CAADE;
    }
    .cont-box .item1-box .table-body .num-box{
        display: flex;
        justify-content: space-between;
        padding-top: .2rem;
    }
    .cont-box .item1-box .table-body .price-box,.cont-box .item1-box .table-body .rate-box{
        padding-top: .1rem;
    }
    .cont-box .item1-box .table-body .price-box{
        display: flex;
        justify-content: space-between;
    }
    .cont-box .item2-box .cont1{
        padding: .2rem .24rem;
        color: #e2e2e2;
        font-size: .26rem;
    }
    .cont-box .item2-box .ul-box{
        padding: 12px 12px 18px;
        background: #162335;
    }
    .cont-box .item2-box .ul-box .list{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: .36rem;
        color: #fff;
    }
    .cont-box .item2-box .ul-box .list:last-child{
        margin-bottom: 0;
    }
    .cont-box .item2-box .ul-box .list .t1{
        padding-right: .12rem;
        color: #7286a7;
        font-size: .28rem;
    }
    .cont-box .item2-box .ul-box .list .t2{
        flex: 1;
        text-align: right;
    }
    .kline-box{
        width: 100%!important;
        /* height: 400px!important; */
        background: #101928;
    }
    .btn-box{
        position: fixed;
        bottom: 0;
        z-index: 99;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: .16rem .28rem;
        background: #18293e;
        box-sizing: border-box;
    }
    .btn-box .btn{
        flex: 1;
        height: .72rem;
        color: #fff;
        font-size: .32rem;
        border-radius: 4px;
    }
    .btn-box .btn.btn-buy{
        background: #00B464;
    }
    .btn-box .btn.btn-sell{
        margin-left: .2rem;
        background: #FA4D56;
    }
    .alert-wrap{
        position: fixed;
        z-index: 1000;
        width: 100%;
        height: 100%;
        padding: 0 .48rem;
        box-sizing: border-box;
    }
    .alert-wrap .alert-box{
        position: relative;
        top: 50%;
        width: 100%;
        padding: 0 .2rem;
        border-radius: .12rem;
        background: #374c7c;
        transform: translateY(-50%);
        box-sizing: border-box;
    }
    .alert-wrap .alert-box .alert-head{
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .24rem 0 .2rem;
        border-bottom: 1px solid #838da5;
    }
    .alert-wrap .alert-box .alert-head .title{
        color: #fff;
        font-size: .28rem;
    }
    .alert-wrap .alert-box .alert-head .btn-close{
        width: .28rem;
        height: .28rem;
    }
    .alert-wrap .alert-box .order-head{
        justify-content: center;
        border-bottom: none;
    }
    .alert-wrap .alert-box .alert-head .close{
        position: absolute;
        top: 50%;
        right: .2rem;
        width: .28rem;
        height: .28rem;
        margin-top: -.14rem;
    }
    .alert-wrap .alert-box .circle-box{
        position: relative;
        width: 1.68rem;
        height: 1.68rem;
        line-height: 1.36rem;
        margin: .16rem auto .28rem;
        border: .16rem solid #232a44;
        border-radius: 50%;
    }
    .alert-wrap .alert-box .circle-box .text{
        color: #4bb3e8;
        font-size: .4rem;
        text-align: center;
    }
    .alert-wrap .alert-box .circle{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 1.68rem;
        height: 1.68rem;
        border: .16rem solid #4bb3e8;
        border-radius: 50%;
        transform: translate(-50%,-50%);
    }
    .alert-wrap .alert-box .price-box{
        padding: .74rem 0 .92rem;
        color: #00c488;
        text-align: center;
    }
    .alert-wrap .alert-box .price-box .num{
        font-size: .4rem;
    }
    .alert-wrap .item-box{
        padding: 0 .4rem;
    }
    .alert-wrap .item-box .item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #c3c3c3;
        padding-bottom: .36rem;
    }
    .alert-wrap .item-box .item .t1{
        color: #fff;
    }
    .alert-wrap .item-box .item .t2{
        color: #00B464;
    }
    .alert-wrap .alert-btn-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .2rem 0 .36rem;
    }
    .alert-wrap .alert-btn-box .btn{
        height: .68rem;
        color: #fff;
        border-radius: 4px;
        text-align: center;
    }
    .alert-wrap .alert-btn-box .btn.close{
        width: 1.6rem;
        margin-right: .2rem;
        background: #367d99;
    }
    .alert-wrap .alert-btn-box .btn.order{
        flex: 1;
        background: #4bb3e8;
    }
    .alert-wrap .alert-tips{
        padding: .2rem 0;
        color: #c3c3c3;
    }
    .alert-wrap .time-wrap{
        width: 100%;
        height: 1.88rem;
        overflow: hidden;
    }
    .alert-wrap .time-wrap .time-box{
        width: 100%;
        height: 1.88rem;
        white-space: nowrap;
        overflow-x: auto;
    }
    .alert-wrap .time-wrap .time-item{
        position: relative;
        display: inline-block;
        width: 1.88rem;
        height: 1.8rem;
        margin-right: 9px;
        font-size: .26rem;
        border: 2px solid transparent;
        border-radius: 6px;
        background: #30385d;
        text-align: center;
    }
    .alert-wrap .time-wrap .time-item.active{
        border: 2px solid #4bb3e8;
    }
    .alert-wrap .time-wrap .time-item .icon{
        position: absolute;
        right: -2px;
        top: -3px;
        width: .76rem;
        height: .72rem;
    }
    .alert-wrap .time-wrap .time-item .t1{
        padding: .24rem 0 .18rem;
        color: #8e8e8e;
    }
    .alert-wrap .time-wrap .time-item .time{
        color: #4bb3e8;
    }
    .alert-wrap .time-wrap .time-item .num{
        font-size: .32rem;
    }
    .alert-wrap .time-wrap .time-item .t2{
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: .1rem 0;
        color: #db4949;
        border-radius: 0 0 .12rem .12rem;
        background: rgba(0,0,0,.5);
    }
    .alert-wrap .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: .72rem;
        border-radius: .12rem;
        background: #30385d;
    }
    .alert-wrap .input-box .input{
        flex: 1;
        height: .72rem;
        padding: 0 .18rem;
        color: #fff;
    }
    .alert-wrap .input-box .text{
        color: #c3c3c3;
        padding-right: 10px;
    }
    .alert-wrap .ky-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .24rem 0;
        color: #c3c3c3;
        border-bottom: 1px solid #838da5;
    }
    .alert-wrap .trade-wrap{
        padding: .16rem 0 .4rem;
    }
    .alert-wrap .trade-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .alert-wrap .trade-box .text{
        width: 33.33%;
        color: #c3c3c3;
    }
    .alert-wrap .trade-item{
        padding-top: .28rem;
    }
    .alert-wrap .trade-item .t1{
        color: #fff;
    }
    .alert-wrap .trade-item .t2{
        color: #00B464;
    }
    .alert-wrap .trade-item .t3{
        color: #4bb3e8;
    }
    .alert-bz-wrap{
        position: fixed;
        top: 0;
        z-index: 1000;
        width: 5.7rem;
        height: 100%;
        background: rgba(26, 36, 63,.9);
        overflow: hidden;
        animation: turn .5s linear;
    }
    @keyframes turn {
        0% {
            width: .8rem;
        }
        20% {
            width: 1.6rem;
        }
        40% {
             width: 2.4rem;
        }
        60% {
             width: 3.2rem;
        }
        80% {
             width: 4rem;
        }
        100% {
             width: 5.4rem
        }
    }
    .alert-bz-wrap .alert-box{
        position: absolute;
        top: 0;
        bottom: 0;
        z-index: 999;
        width: 100%;
        height: auto;
    }
    .alert-bz-wrap .alert-box .alert-li{
        display: flex;
        align-items: center;
        width: 100%;
        height: 1rem;
        padding: 0 .44rem;
        color: #fff;
        font-size: .26rem;
        line-height: 1rem;
        border-bottom: 1px solid #858585;
        box-sizing: border-box;
    }
    .alert-bz-wrap .alert-box .alert-li:last-child{
        border: none;
    }
    .alert-bz-wrap .alert-box .alert-li .money{
        flex: 1;
        color: #00B464;
        text-align: right;
    }
    .alert-bz-wrap .alert-box .icon{
        margin-right: .38rem;
        width: .58rem;
        height: .58rem;
    }
    .alert-bz-wrap .alert-btn{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 1.3rem;
        color: #fff;
        font-size: .36rem;
        line-height: 1.3rem;
        border-top: 2px solid #3A4560;
        background: #1A243F;
        text-align: center;
    }
    /* 买入 */
    .alert-buy-box{
        position: fixed;
        bottom: 0;
        z-index: 1000;
        width: 100%;
        padding: 0 .26rem;
        color: #fff;
        font-size: .28rem;
        background: #1A243F;
        border-radius: .34rem .34rem 0 0;
        box-sizing: border-box;
    }
    .alert-buy-box .buy-head{
        position: relative;
        padding: .56rem .16rem;
        color: #fff;
        font-size: .28rem;
    }
    .alert-buy-box .buy-head .price{
        color: #00C483;
        font-size: .32rem;
    }
    .alert-buy-box .buy-head .price.red{
        color: #FA4D56;
    }
    .alert-buy-box .buy-head .price.green{
        color: #00C483;
    }
    .alert-buy-box .buy-head .close{
        position: absolute;
        right: 0;
        top: .56rem;
        width: .34rem;
        height: .34rem;
    }
    .alert-buy-box .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: .84rem;
        padding: 0 .22rem;
        font-size: .28rem;
        border: 1px solid #E1E1E1;
    }
    .alert-buy-box .input-box .input{
        flex: 1;
        color: #E1E1E1;
        background: transparent;
    }
    .alert-buy-box .input-box .text{
        color: #E1E1E1;
    }
    .alert-buy-box .ky-money{
        margin-top: .42rem;
        display: flex;
    }
    .alert-buy-box .ky-money .ky-buy{
        /* margin-left: .38rem; */
    }
    .alert-buy-box .ky-money .blue{
        color: #74D0FF;
        padding-left: .2rem;
    }
    .alert-buy-box .rate,.alert-buy-box .money{
        margin-top: .42rem;
    }
    .alert-buy-box .btn{
        width: 6.75rem;
        height: .92rem;
        margin: .36rem auto .42rem;
        color: #fff;
        font-size: .36rem;
        line-height: .92rem;
        background: #00C483;
        border-radius: .06rem;
        text-align: center;
    }
    .alert-buy-box .btn.btn-sell{
        background: #D14B65;
    }
    .alert-wrap2{
        position: absolute;
        left: 1rem;
        right: 1rem;
        top: 50%;
        z-index: 1000;
        width: auto;
        background: #1A2440;
        border-radius: .2rem;
        transform: translateY(-50%);
    }
    .alert-wrap2 .alert-head{
        position: relative;
        padding: .28rem 0 .5rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap2 .alert-head .icon{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .3rem;
        height: .3rem;
    }
    .alert-wrap2 .cont{
        max-height: 6rem;
        padding: 0 .4rem .72rem .36rem;
        color: #fff;
        font-size: .28rem;
        overflow: auto;
    }
    .pwd-alert-box{
        position: fixed;
        left: .5rem;
        right: .5rem;
        top: 50%;
        z-index: 1000;
        width: auto;
        padding: .26rem .46rem .68rem .46rem;
        background: rgba(55, 76 ,124,.9);
        border-radius: .07rem;
        box-sizing: border-box;
        transform: translateY(-50%);
    }
    .pwd-alert-box .alert-head{
        position: relative;
        padding: 0 .06rem;
        color: #fff;
        font-size: .28rem;
        text-align: center;
    }
    .pwd-alert-box .close{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .24rem;
        height: .24rem;
    }
    .pwd-alert-box .pwd-box{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: .5rem;
        border: 1px solid #fff;
    }
    .pwd-alert-box .pwd-box .pwd{
        flex: 1;
        height: .7rem;
    }
    .pwd-alert-box .pwd-box .pwd .input{
        width: 100%;
        height: .7rem;
        color: #fff;
        font-size: .4rem;
        border-right: 1px solid #fff;
        background: #374C7C;
        text-align: center;
        box-sizing: border-box;
        border-radius: 0;
        font-weight: bold;
        outline: none;
    }
    .pwd-alert-box .pwd-box .pwd:last-child .input{
        border-right: none;
    }
    .alert-pay{
        position: absolute;
        left: 1.3rem;
        right: 1.18rem;
        top: 50%;
        z-index: 1000;
        width: auto;
        background: #1A2440;
        border-radius: .2rem;
        transform: translateY(-50%);
    }
    .alert-pay .alert-head{
        position: relative;
        padding: .28rem 0 .5rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-pay .alert-head .icon{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .3rem;
        height: .3rem;
    }
    .alert-pay .cont{
        max-height: 6rem;
        padding: 0 .8rem .72rem .72rem;
        color: #fff;
        font-size: .28rem;
        overflow: auto;
    }
    .alert-pay{
        background: #1a243f;
    }
    .alert-pay .alert-head{
        padding: .5rem .4rem;
        font-size: .28rem;
        border-bottom: 1px solid #858585;
    }
    .alert-pay .alert-btn{
        padding: .3rem 0;
        color: #2CAADE;
        font-size: .32rem;
        text-align: center;
    }
    .go-top{
        bottom: 1.04rem;
    }
</style>
<style lang="">
    .kline-box,.kline-box canvas{
        width: 100%!important;
        height: 400px!important;
        overflow: auto;
    }
</style>



// WEBPACK FOOTER //
// src/pages/kline.vue